import { cn } from '../../lib/utils';
import type { ReactNode } from 'react';
import { Group, Stack } from '@folio/components/ui/flex';
import { Title } from '@folio/components/ui/text';

interface PageHeaderProps {
  title?: ReactNode;
  right?: ReactNode;
  subtitle?: ReactNode;
  className?: string;
}

export function PageHeader({ title, subtitle, right, className }: PageHeaderProps) {
  return (
    <Group justify="between" gap={0} className={cn('mb-4', className)}>
      <Stack gap={2}>
        <Title order={1} size="2xl" tone="primary" className="sm:text-4xl">
          {title}
        </Title>
        <h4>{subtitle}</h4>
      </Stack>
      <Group align="stretch" gap={0} className="space-x-4">
        {right}
      </Group>
    </Group>
  );
}
